import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "builder-get-started-tab-container" }
const _hoisted_2 = {
  key: 0,
  class: "builder-images-wr"
}
const _hoisted_3 = ["src"]
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "builder-get-started-button-wr" }
const _hoisted_6 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ($setup.isDesktop)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.carouselImages.slice(0, 3), (image) => {
            return (_openBlock(), _createElementBlock("img", {
              class: "builder-carousel-img",
              key: image,
              src: require(`@/assets/images/builder/${image}`)
            }, null, 8, _hoisted_3))
          }), 128))
        ]))
      : (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "builder-carousel-wr",
          ref: "builderCarousel",
          onScroll: $setup.handleScroll
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.carouselImages, (image) => {
            return (_openBlock(), _createElementBlock("img", {
              class: "builder-carousel-img",
              key: image,
              src: require(`@/assets/images/builder/${image}`)
            }, null, 8, _hoisted_4))
          }), 128))
        ], 544)),
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "builder-get-started-info" }, [
      _createElementVNode("div", { class: "get-started-info" }, "Compare home designs from a list of high-quality home builders and create your own home and land package to fit your budget and design preferences.")
    ], -1)),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("button", {
        class: _normalizeClass(["button default primary", { disabled: $setup.props.buttonDisabled }]),
        disabled: $setup.props.buttonDisabled,
        onClick: _cache[0] || (_cache[0] = ($event: any) => ($setup.emits('onRequestQuote')))
      }, "Get started", 10, _hoisted_6)
    ])
  ]))
}